const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;
const BEIJING_OFFSET_MS = 8 * HOUR_MS;
const REFRESH_HOURS = [0, 4, 8, 12, 16, 20];

// 使用固定 UTC+8，避免用户所在时区或夏令时改变刷新时间。
export function getNextPageRefreshTime(now = Date.now()) {
  const dayStart = Math.floor((now + BEIJING_OFFSET_MS) / DAY_MS) * DAY_MS - BEIJING_OFFSET_MS;
  for (const hour of REFRESH_HOURS) {
    const candidate = dayStart + hour * HOUR_MS;
    if (candidate > now) return candidate;
  }
  return dayStart + DAY_MS + REFRESH_HOURS[0] * HOUR_MS;
}

export function startScheduledPageRefresh(onRefresh = () => window.location.reload()) {
  // 每次真正加载页面后等待下一个时间点，不在整点刷新后形成循环。
  const dueAt = getNextPageRefreshTime();
  let timer;
  let stopped = false;

  const cleanup = () => {
    stopped = true;
    window.clearTimeout(timer);
    document.removeEventListener('visibilitychange', handleVisibility);
    window.removeEventListener('focus', check);
    window.removeEventListener('pageshow', check);
  };

  const check = () => {
    if (stopped) return;
    window.clearTimeout(timer);
    if (Date.now() >= dueAt) {
      cleanup();
      onRefresh();
      return;
    }
    // 限制单次等待时间，兼容设备时钟调整和后台定时器延迟。
    timer = window.setTimeout(check, Math.min(dueAt - Date.now(), 60 * 1000));
  };

  const handleVisibility = () => {
    if (document.visibilityState === 'visible') check();
  };

  document.addEventListener('visibilitychange', handleVisibility);
  window.addEventListener('focus', check);
  window.addEventListener('pageshow', check);
  check();
  return cleanup;
}
